<template>
  <div class="index">
    <!-- 选择查询条件 -->
    <div class="index-header">
      <el-form :model="filterForm" :inline="true" label-width="120px">
        <div class="input-box">
          <div>
            <el-form-item label="案件标题：">
              <el-input clearable v-model="filterForm.title" placeholder="请输入案件标题"></el-input>
            </el-form-item>
            <el-form-item label="委托律师：">
              <el-input clearable v-model="filterForm.l_name" placeholder="请输入委托律师"></el-input>
            </el-form-item>
            <el-form-item label="涉案类型：">
              <el-select v-model="filterForm.caseType" clearable placeholder="请选择涉案类型">
                <el-option v-for="(x,i) in $fuwuData.laytype1" :key="i" :label="x" :value="x"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <areaFilter ref="areaFilter_filter" @getData="filterClick" />
          </div>
          <div>
            <el-form-item>
              <el-button type="primary" @click="filterClick()" icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 用户操作按钮 -->
    <div class="edit">
      <el-button :disabled="selectRow.length!==1" icon="el-icon-edit" @click="modifyHandler" v-if="powerShow.modify">编辑</el-button>
      <!-- <el-button icon="el-icon-edit" @click="createHandler" v-if="powerShow.create">创建</el-button> -->
      <el-button :disabled="selectRow.length<1" icon="el-icon-delete" type="danger" @click="deleteHandler('ajwt')" v-if="powerShow.delete">删除</el-button>
    </div>
    <!-- 数据表格 -->
    <div class="table">
      <el-table :data="tableData" max-height="550" border @selection-change="(val)=>{selectRow=val}">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.value" :fixed="i<=7" align="center"></el-table-column>
        
        <!-- <el-table-column label="图片" width="190" align="center">
          <template slot-scope="scope">
            <div style="margin:0 10px;">
              <el-image
                fit="contain" :src="scope.row.homeUrl|toimg" v-if="scope.row.homeUrl"
                :preview-src-list="_preview_handler(scope.row.homeUrl,[scope.row.homeUrl])"/>
            </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="操作" width="260" align="center">
          <template slot-scope="scope">
            <el-button class="my-button-20" size="mini" plain type="warning" @click="onlineHandler(scope.row.id,false)" v-if="scope.row.online">下线</el-button>
            <el-button class="my-button-20" size="mini" plain type="success" @click="onlineHandler(scope.row.id,true)" v-else>上线</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <paging :pagesData="pageData" @set_page_number="get_page_number"></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="案件委托信息" :modal="false" width="1400px" center :visible.sync="centerDialogVisible"
      :close-on-click-modal="false" @close="dialogClose">
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">案件委托信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-form-item label="选择地区">
                        <areaFilter ref="areaFilter_dialog" :areaIdsChecked="areaIdsChecked" />
                      </el-form-item>
                      <el-form-item label="案件标题：" prop="title">
                        <el-input v-model="editForm.title"></el-input>
                      </el-form-item>
                      <el-form-item label="委托人电话：" prop="phone">
                        <el-input v-model="editForm.phone"></el-input>
                      </el-form-item>
                      <el-form-item label="律师姓名：">
                        <el-input v-model="editForm.l_name"></el-input>
                      </el-form-item>
                      <el-form-item label="律师联系方式：">
                        <el-input v-model="editForm.l_phone"></el-input>
                      </el-form-item>
                      <el-form-item label="案件类别：">
                        <el-select v-model="editForm.caseType" placeholder="请选择案件类别">
                          <el-option v-for="(x,i) in $fuwuData.laytype1" :key="i" :label="x" :value="x"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="涉案金额：">
                        <el-input v-model="editForm.caseCash"></el-input>
                      </el-form-item>
                      <el-form-item label="律师办公地址：">
                        <el-input v-model="editForm.l_wordAddress"></el-input>
                      </el-form-item>
                      <el-form-item label="涉案事实：" prop="content">
                        <el-input
                          type="textarea" :rows="5" maxlength="2000" show-word-limit
                          v-model="editForm.content" placeholder="请输入内容"></el-input>
                      </el-form-item>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose()">取 消</el-button>
        <el-button type="primary" @click="dialogSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 图片预览 -->
    <!-- <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog> -->
  </div>
</template>

<script>
// import mixin_upload from '@/Mixins/mixin_upload'
import areaFilter from '@/components/areaFilter'
import mixins from '@/Mixins/mixin_3g48_back'
import { powerMap } from '@/publicData/powerData'
// import E from 'wangeditor'
// 导入封装好的公共组件wangEditor
// import EditorBar from '@/components/wangEditor'
export default {
  mixins: [mixins],//, mixin_upload
  components: { areaFilter },//, EditorBar
  data() {
    return {
      sign: 'weituo',
      // catalog: 'activity',
      baseInfo: [
        { key: 'province', value: '省' },
        { key: 'city', value: '市' },
        { key: 'county', value: '县' },
        { key: 'town', value: '镇' },
        { key: 'village', value: '村' },
        { key: 'title', value: '委托标题' },
        { key: 'l_name', value: '律师姓名' },
        { key: 'caseType', value: '涉案类别' },
        { key: 'phone', value: '委托人电话' },
        { key: 'l_phone', value: '律师联系方式' },
        { key: 'l_wordAddress', value: '律师办公地址' },
        { key: 'createTime', value: '委托时间' },
      ],
    }
  },
  methods: {
    // modifyHandlerCb() {
    //   let id = this.editForm.homeUrl
    //   this.fileList_1 = id ? [{ name: id, url: this.puUrl_x + '/' + id, id }] : []
    // },
    // onlineHandler(id, online) {
    //   let rD = { id, online }
    //   this.$api.util_modify(this.sign, rD).then(res => {
    //     if (res.data.status == 0) {
    //       this.$message.success('设置成功')
    //       this.filterHandler()
    //     } else { this._status(res.data) }
    //   })
    // },
    dialogSubmit() {
      console.log(this.editForm)
      let rD = {}
      let { title, phone, content } = this.editForm

      let areaNames = this.$refs.areaFilter_dialog.findAreaNames()
      const mapList = ['province','city','county','town','village']
      areaNames.forEach((x, i) => {
        x ? rD[mapList[i]] = x : ''
      })

      if (!rD.province) { this.$message.warning('请选择地区') }
      else if (!title) { this.$message.warning('请输入委托标题') }
      else if (!phone) { this.$message.warning('请输入委托人电话') }
      else if (!content) { this.$message.warning('请输入委托内容') }
      else {
        // this.editForm.homeUrl = this.fileList_1[0].id
        console.log(`%crD:`, 'color: #f00;', rD)
        
        if (this.isCreate) {
          const mapList2 = ['title', 'phone', 'l_name', 'caseType', 'caseCash', 'l_phone', 'l_wordAddress', 'content']//'homeUrl'
          mapList2.forEach(x => {
            // console.log(this.selectRow[0][x], this.editForm[x])
            rD[x] = this.editForm[x]
          })
          // rD.catalog = this.catalog
          this.$api.util_create(this.sign, rD).then(res => {
            if (res.data.status == 0) {
              this.$message.success('创建成功')
              this.filterHandler()
              this.dialogClose()
            } else { this._status(res.data) }
          })
        } else {
          const mapList2 = ['title', 'phone', 'l_name', 'caseType', 'caseCash', 'l_phone', 'l_wordAddress', 'content']//'homeUrl'
          mapList2.forEach(x => {
            // console.log(this.selectRow[0][x], this.editForm[x])
            if (this.selectRow[0][x] !== this.editForm[x]) {
              rD[x] = this.editForm[x]
            }
          })
          rD.id = this.editForm.id
          this.$api.util_modify(this.sign, rD).then(res => {
            if (res.data.status == 0) {
              this.$message.success('修改成功')
              this.filterHandler()
              this.dialogClose()
            } else { this._status(res.data) }
          })
        }

        // console.log(`%crD:`, 'color: #00f;', rD)
      }
      // const mapList = ['dealOptions']
      // this.dialogSubmitCb(mapList, { status: 2 })
    },
    getData(rD = {}) {
      // rD.catalog = this.catalog
      this.getDataCb(rD)
    },
  },
  created() {
    const powerList = this.userInfo.privilegesList
    const powerStr = powerMap[this.sign]
    const mapList = ['search','create','modify','delete','import','export']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.powerShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (powerList.includes(powerStr + '-' + x)) {
          this.powerShow[x] = true
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
/* @import url(); 引入css类 */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
/deep/ .hide .el-upload--picture-card {display: none;}
</style>